<template>
  <span class="badge" :style="`border: 2px solid ${color}`">{{ label }}</span>
</template>

<script>
export default {
  name: "BaseBadge",
  props: {
    label: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: "var(--color-text-primary)",
    },
  },
};
</script>

<style scoped>
.badge {
  display: inline-block;
  padding: 1px 8px;
  min-width: 50px;
  min-height: 8px;
  white-space: nowrap;
  vertical-align: baseline;
  color: var(--color-text-secondary);
  text-align: center;
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  border-radius: 20px;
}
</style>
